export const ROLES = new Map<string, string>([
  ['admin', 'ROLE_ADMIN'],
  ['member', 'ROLE_USER'],
]);
